// @flow
import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import DialogContentText from "@mui/material/DialogContentText";
import dayjs from "dayjs";
import * as React from 'react';
import { Trans, useTranslation } from "react-i18next";
import ConfirmDialog from "../../../components/app/dialogs/confirmDialog/confirmDialog";
import CustomTranslation from "../../../components/general/customTranslation/customTranslation";
import { Permissions } from "../../../helpers/constants";
import { eventStatus, formatDate } from "../../../helpers/date";
import { dialogueContextTextDefaults } from "../../../helpers/theme/defaultProps";
import useUserData from "../../../hooks/user/useUserData";
import { EXHIBITOR_PROFILE } from "../../../locales/components/namespaces";
import { useHasPermission } from "../../../modules/permission/hooks/useHasPermission";
import CatalogueExample from "./catalogueExample";

type Props = {};

export const CatalogueInfo = (props: Props) => {
	const { t } = useTranslation(EXHIBITOR_PROFILE)
	const { open, onClose, exhibition } = props
	const { dateFormat } = useUserData()
	const { catalogLocked, dateFrom, dateTo, daysForCatalogSubmission, translations } = exhibition
	const isOrganizer = useHasPermission([Permissions.BeOrganizer], { shouldView: true })
	const status = eventStatus(dateFrom, dateTo)
	const dayBeforeCatalogSubmission = dayjs(dateFrom).subtract(daysForCatalogSubmission, 'd')
	const canFillCatalogIsBefore = dayjs().isSame(dayBeforeCatalogSubmission, 'day')
	const canFillCatalogIsSame = dayjs().isBefore(dayBeforeCatalogSubmission, 'day')
	const canFillCatalog = canFillCatalogIsBefore || canFillCatalogIsSame
	const catalogDisabled = (isOrganizer && catalogLocked) || (!isOrganizer && (catalogLocked || status !== eventStatus.status.UPCOMING || !canFillCatalog))
	
	return !catalogDisabled && (
		<React.Fragment>
			<Box
				onClick={(e) => e.stopPropagation()}
			>
				<ConfirmDialog
					maxWidth={"md"}
					open={open}
					handleDialog={onClose}
					title={t("Catalogue Entry Instructions")}
					yesAction={false}
					noAction={false}
				>
					<DialogContentText
						{...dialogueContextTextDefaults}
					>
						<CustomTranslation
							code={'catalogue_instructions'}
							translations={translations}
						>
							<List>
								<ListItem component={"div"}>
									<ListItemText
										primary={
											<Typography component={"div"} variant={"body"}
														sx={{ color: 'text.main' }}>
												<Trans
													i18nKey={'catalog_info'}
													ns={EXHIBITOR_PROFILE}
													components={{ bold: <strong/>, a: <a/> }}
													values={{
														email: "support@rota.gr",
														date: dayBeforeCatalogSubmission ? formatDate(dayBeforeCatalogSubmission, dateFormat) : ''
													}}
													defaults={'Please check and carefully complete your details for the catalogue according to the instructions displayed bellow. <br/><br/> The "Company Name" you will fill in should appear in the exhibitor list. <br/><br/>  Final submission deadline for catalog details: {{date}}.'}
												/>
											</Typography>
										}
									/>
								</ListItem>
								<ListItem component={"div"}>
									<CatalogueExample
										catalogueLanguage={exhibition?.catalogueLanguage}
									/>
								</ListItem>
							</List>
						</CustomTranslation>
					</DialogContentText>
				</ConfirmDialog>
			</Box>
		</React.Fragment>
	);
};